import { render, staticRenderFns } from "./DmpTemplateNotification.vue?vue&type=template&id=1131e30d&scoped=true"
import script from "./DmpTemplateNotification.vue?vue&type=script&lang=js"
export * from "./DmpTemplateNotification.vue?vue&type=script&lang=js"
import style0 from "./DmpTemplateNotification.vue?vue&type=style&index=0&id=1131e30d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131e30d",
  null
  
)

export default component.exports